import InvoicePage from "./InvoicePage";

const Index = () => <InvoicePage />;

export default Index;